import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformeConteudoEmAprendizado from "./sections/TransformeConteudoEmAprendizado";
import PorqueEscolherANexora from "./sections/PorqueEscolherANexora";
import CuratedRetreatSelection from "./sections/CuratedRetreatSelection";
import TravelerTestimonials from "./sections/TravelerTestimonials";
import JornadaDaInstalacao from "./sections/JornadaDaInstalacao";
import TransformeSeuSorrisoHoje from "./sections/TransformeSeuSorrisoHoje";
import PremiumTravelGallery from "./sections/PremiumTravelGallery";
import PremiumGoogleReviews from "./sections/PremiumGoogleReviews";
import Destinations from "./sections/Destinations";
import KgViagensRodape from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <main>
        <TransformeConteudoEmAprendizado />
        <Destinations />
        <PorqueEscolherANexora />
        <CuratedRetreatSelection />
        <TravelerTestimonials />
        <PremiumGoogleReviews />
        <JornadaDaInstalacao />
        <PremiumTravelGallery />
        <TransformeSeuSorrisoHoje />
      </main>
      <KgViagensRodape />
    </div>;
}